export default __webpack_public_path__ + "static/media/establishment.7c9c13b7.svg";